function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useCallback } from "react";
import { useTopicMembersPageQuery, ItemType, ItemMemberLevel, useTopicMembersPage_DeleteTopicInviteMutation, UserType } from "sprout-graphql";
import { useParams, Link } from "react-router-dom";
import useLoadingProgress from "@sprout/hooks/dist/useLoadingProgress";
import { Glitch, NotFound } from "@sprout/views";
import Head from "@sprout/client-layout/dist/Head";
import { Button } from "sprout-ui-dom/dist/Button";
import { getItemUrl, isNotNullish } from "sprout-lib";
import { useNavigationList } from "@sprout/list-navigation";
import { Page } from "@sprout/client-layout";
import { EmailCard } from "@sprout/client-components/dist/Cards";
import { Box, Flex, Text } from "sprout-ui-primitives";
import styled from "styled-components";
import { media } from "sprout-ui-theme";
import { sortTopicMembers } from "@sprout/client-lib";
import TopicMembersPageAppBarMobile from "./TopicMembersPage_AppBar_Mobile";
import TopicMembersPageTopicMember from "./TopicMembersPage_TopicMember";
const SUPPORTED_ACTIONS = [
    "OPEN"
];
const TopicMembersPageMembers = (props)=>{
    const { topicMembers , teamMemberIds , topic , memberLevel  } = props;
    const { owner  } = topic;
    const { Provider , navProps  } = useNavigationList(String(`TopicMembersPage|${topic.id}`), useMemo(()=>({
            actions: SUPPORTED_ACTIONS
        }), []));
    return /*#__PURE__*/ _jsx(Provider, {
        children: /*#__PURE__*/ _jsx("div", _objectSpread({}, navProps, {
            children: topicMembers.map((topicMember)=>{
                var ref;
                return topicMember.user ? /*#__PURE__*/ _jsx(TopicMembersPageTopicMember, {
                    isPartOfPaidTeam: (owner === null || owner === void 0 ? void 0 : owner.type) === UserType.Team && ((ref = topicMember.user) === null || ref === void 0 ? void 0 : ref.id) != null && teamMemberIds.includes(topicMember.user.id),
                    currentUserMemberLevel: memberLevel,
                    topic: topic,
                    topicMember: topicMember
                }, topicMember.nodeId) : null;
            })
        }))
    });
};
const NavigationBreadcrumbs = styled(Flex)`
  border-radius: 30px;
  margin-bottom: 24px;

  ${media.target("pointer")} {
    a:hover {
      text-decoration: underline;
    }
  }

  ${media.up("medium", "pointer")} {
    margin-bottom: 16px;
  }
`;
const TopicMembersPage = ()=>{
    const { topicId  } = useParams();
    const { loading , data , error  } = useTopicMembersPageQuery({
        variables: {
            topicId: Number(topicId)
        },
        fetchPolicy: "cache-and-network"
    });
    const topic = data === null || data === void 0 ? void 0 : data.topic;
    const initialLoad = loading && !topic;
    useLoadingProgress(initialLoad);
    const [topicMembers, emailInvites] = useMemo(()=>{
        if (!topic) return [
            [],
            []
        ];
        return [
            sortTopicMembers(topic.topicMembers.nodes),
            topic.emailInvites.nodes, 
        ];
    }, [
        topic
    ]);
    const teamMemberIds = useMemo(()=>{
        var ref1;
        const nodes = topic === null || topic === void 0 ? void 0 : (ref1 = topic.owner) === null || ref1 === void 0 ? void 0 : ref1.teamMembers.nodes;
        if (!nodes) return [];
        return nodes.filter((node)=>node.active && node.userByMemberId).map((node)=>{
            var ref;
            return (ref = node.userByMemberId) === null || ref === void 0 ? void 0 : ref.id;
        }).filter(isNotNullish);
    }, [
        topic
    ]);
    const [deleteTopicInvite] = useTopicMembersPage_DeleteTopicInviteMutation();
    const handleDeleteTopicInvite = useCallback((_event, id)=>{
        deleteTopicInvite({
            variables: {
                id
            }
        }).catch((e)=>{
            console.error(e);
        });
    }, [
        deleteTopicInvite
    ]);
    if (initialLoad) return null;
    if (error) return /*#__PURE__*/ _jsx(Glitch, {
        error: error
    });
    if (!topic || topic.type !== ItemType.Topic || !topic.isRootTopic) return /*#__PURE__*/ _jsx(NotFound, {});
    const { membersCanInviteMembers , memberLevel , title  } = topic;
    const canCurrentUserInviteMembers = memberLevel && [
        ItemMemberLevel.Admin,
        ItemMemberLevel.Owner
    ].includes(memberLevel) || memberLevel === ItemMemberLevel.Contributor && membersCanInviteMembers;
    const rootURL = getItemUrl(topic, topic.owner);
    const inviteURL = `${rootURL}/invite`;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Head, {
                title: "Tree Members | Sprout"
            }),
            /*#__PURE__*/ _jsx(TopicMembersPageAppBarMobile, {
                inviteURL: inviteURL
            }),
            /*#__PURE__*/ _jsxs(Page, {
                variant: "shadow",
                aboveTitle: /*#__PURE__*/ _jsx(NavigationBreadcrumbs, {
                    px: 3,
                    minHeight: "32px",
                    as: "nav",
                    alignItems: "center",
                    justifyContent: "center",
                    mx: "auto",
                    children: /*#__PURE__*/ _jsx(Text, {
                        as: Link,
                        to: rootURL,
                        color: "blue.500",
                        children: title || "No title"
                    })
                }),
                title: "Members",
                appBar: canCurrentUserInviteMembers ? /*#__PURE__*/ _jsx(Box, {
                    ml: "auto",
                    children: /*#__PURE__*/ _jsx(Button, {
                        variant: "purple",
                        as: Link,
                        to: inviteURL,
                        children: "Invite"
                    })
                }) : undefined,
                children: [
                    topicMembers.length !== 0 && /*#__PURE__*/ _jsx(TopicMembersPageMembers, {
                        topic: topic,
                        topicMembers: topicMembers,
                        teamMemberIds: teamMemberIds,
                        memberLevel: memberLevel
                    }),
                    emailInvites.length !== 0 && emailInvites.map((emailInvite)=>/**
             * TODO: change this when `EmailCard` is converted to TS
             */ /*#__PURE__*/ _jsx(EmailCard, {
                            // @ts-ignore
                            email: emailInvite,
                            // @ts-ignore
                            onRemovingClick: memberLevel === ItemMemberLevel.Owner ? handleDeleteTopicInvite : null
                        }, emailInvite.nodeId))
                ]
            })
        ]
    });
};
export default TopicMembersPage;
